import { FinancialDisclosuresTable } from "@/components/financial-disclosures/financial-disclosures-table";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/website/disclosures/")({
  component: FinancialDisclosuresTable,
});
